/**
 * Teppichstadt Theme - Product Variant Selector & AJAX Cart Submitter
 */

document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.getElementById('AddToCartForm');
  if (!productForm) return;

  const productSection = productForm.closest('.product-detail-section');
  if (!productSection) return;

  const sectionId = productSection.getAttribute('data-section-id');
  const variantsJsonEl = document.getElementById(`ProductVariantsJson-${sectionId}`);
  if (!variantsJsonEl) return;

  let productVariants = [];
  try {
    productVariants = JSON.parse(variantsJsonEl.textContent);
  } catch (e) {
    console.error('Failed to parse product variants JSON:', e);
    return;
  }

  // Selected state mapping
  let selectedOptions = {};

  // DOM elements cache
  const variantInput = productForm.querySelector('input[name="id"]');
  const priceContainer = document.getElementById(`ProductPrice-${sectionId}`);
  const addToCartBtn = productForm.querySelector('.product-info__cart-btn');

  // Initialize selected values from the active elements in the template
  function initializeOptions() {
    const activeButtons = productSection.querySelectorAll('.option-value.active');
    activeButtons.forEach(button => {
      const optionIndex = `option${button.getAttribute('data-option')}`;
      const optionVal = button.getAttribute('data-value');
      selectedOptions[optionIndex] = optionVal;
    });

    // If options are missing (has default variant), set first available
    if (Object.keys(selectedOptions).length === 0 && productVariants.length > 0) {
      const firstAvailable = productVariants.find(v => v.available) || productVariants[0];
      if (firstAvailable && variantInput) {
        variantInput.value = firstAvailable.id;
      }
    }

    updateOptionsAvailability();
    updateVariantAndPrice();
  }

  // Event handler for selecting options
  productSection.querySelectorAll('.option-value').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      if (this.classList.contains('disabled')) return;

      const optionIndex = `option${this.getAttribute('data-option')}`;
      const value = this.getAttribute('data-value');
      selectedOptions[optionIndex] = value;

      // Update active classes
      const siblingButtons = this.closest('.option-values-list').querySelectorAll('.option-value');
      siblingButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      updateOptionsAvailability();
      updateVariantAndPrice();
    });
  });

  // Check which size/color combinations are sold out and cross them out
  function updateOptionsAvailability() {
    if (productVariants.length === 0) return;

    productSection.querySelectorAll('.option-value').forEach(button => {
      const optionNum = button.getAttribute('data-option');
      const optionIndex = `option${optionNum}`;
      const value = button.getAttribute('data-value');

      // Check if there is at least one available variant with this option value
      // and matching the *other* selected options
      const isAvailable = productVariants.some(variant => {
        let match = true;
        Object.keys(selectedOptions).forEach(key => {
          if (key !== optionIndex) {
            match = match && (variant[key] === selectedOptions[key]);
          }
        });
        return match && variant.available && variant[optionIndex] === value;
      });

      if (!isAvailable) {
        button.classList.add('disabled');
      } else {
        button.classList.remove('disabled');
      }
    });
  }

  // Update real form input ID and dynamic labels
  function updateVariantAndPrice() {
    const matchingVariant = findMatchingVariant();

    if (matchingVariant) {
      if (variantInput) variantInput.value = matchingVariant.id;
      
      // Update Price display
      if (priceContainer) {
        const priceSpan = priceContainer.querySelector('.price-amount');
        if (priceSpan) priceSpan.textContent = formatPrice(matchingVariant.price);

        const compareSpan = priceContainer.querySelector('.compare-price-amount');
        if (compareSpan) {
          if (matchingVariant.compare_at_price > matchingVariant.price) {
            compareSpan.textContent = formatPrice(matchingVariant.compare_at_price);
            compareSpan.style.display = 'inline-block';
          } else {
            compareSpan.style.display = 'none';
          }
        }
      }

      // Update button state
      if (addToCartBtn) {
        if (matchingVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = `${window.translations.addToCart} — ${formatPrice(matchingVariant.price)}`;
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = window.translations.soldOut;
        }
      }

    } else {
      // Sold out fallback state
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = window.translations.soldOut;
      }
    }
  }

  function findMatchingVariant() {
    return productVariants.find(variant => {
      return Object.keys(selectedOptions).every(key => {
        return variant[key] === selectedOptions[key];
      });
    });
  }

  function formatPrice(cents) {
    return window.currencySymbol + (cents / 100).toFixed(2);
  }

  // 7. Intercept Form Submission (AJAX add-to-cart operations)
  productForm.addEventListener('submit', function(e) {
    e.preventDefault();

    const submitBtn = productForm.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const formData = new FormData(productForm);
    const dataObj = {};
    formData.forEach((val, key) => {
      dataObj[key] = val;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: dataObj.id,
        quantity: parseInt(dataObj.quantity || 1)
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add product to cart');
      return response.json();
    })
    .then(item => {
      if (submitBtn) submitBtn.disabled = false;
      
      // Update totals
      if (window.cartType === 'drawer') {
        if (window.refreshCartDrawer) window.refreshCartDrawer();
        
        // Fetch cart count
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            if (window.updateCartCount) window.updateCartCount(cart.item_count);
          });
        
        // Slide open the drawer
        if (window.openCart) window.openCart();
      } else {
        // Fallback: Redirect to Cart page
        window.location.href = '/cart';
      }
    })
    .catch(err => {
      console.error('AJAX add-to-cart failure:', err);
      if (submitBtn) submitBtn.disabled = false;
      alert('Could not add item to bag. Please try again.');
    });
  });

  // Bootstrap Options selectors
  initializeOptions();

  // --- Product Gallery Slider Control ---
  const sliderWrapper = productSection.querySelector('.slider-image-wrapper');
  if (sliderWrapper) {
    const images = sliderWrapper.querySelectorAll('.product-slider-img');
    const leftBtn = productSection.querySelector('#SliderLeftBtn');
    const rightBtn = productSection.querySelector('#SliderRightBtn');
    let currentIndex = 0;

    function showImage(index) {
      if (images.length === 0) return;
      
      // Clamp index
      if (index < 0) {
        currentIndex = images.length - 1;
      } else if (index >= images.length) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }

      images.forEach((img, i) => {
        if (i === currentIndex) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });

      const dots = productSection.querySelectorAll('.slider-dot');
      dots.forEach((dot, i) => {
        if (i === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    const dots = productSection.querySelectorAll('.slider-dot');
    dots.forEach((dot, i) => {
      dot.addEventListener('click', function() {
        showImage(i);
      });
    });

    if (leftBtn && rightBtn) {
      if (images.length > 1) {
        leftBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          showImage(currentIndex - 1);
        });

        rightBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          showImage(currentIndex + 1);
        });
      } else {
        // Hide arrows if only 1 image exists
        leftBtn.style.display = 'none';
        rightBtn.style.display = 'none';
      }
    }
  }

});
